import { ColDef, ColGroupDef, ICellRendererParams } from 'ag-grid-community';
import { emptyCellFormatter } from 'src/util/grid/cellFormatter';
import { getPromoDurationDays } from 'src/util/grid/cellGetter';
import { getTerritoryFlagRenderer } from 'src/util/grid/cellRenderer';

export const thirdPartyRatesColDefs: (ColGroupDef | ColDef)[] = [
    {
        field: 'displayName',
        headerName: 'Plan',
        filter: 'agSetColumnFilter',
        pinned: true,
        width: 300
    },
    {
        headerName: 'Plan inputs',
        groupId: 'planInputs',
        children: [
            {
                field: 'paperPlanName',
                headerName: 'PAPER Plan ID',
                filter: 'agSetColumnFilter',
                width: 400,
                hide: true
            },
            {
                field: 'rateGroup',
                headerName: 'Rate group',
                filter: 'agSetColumnFilter',
                valueFormatter: emptyCellFormatter
            },
            {
                field: 'planGroup',
                headerName: 'Plan group',
                filter: 'agSetColumnFilter',
                hide: true
            },
            {
                field: 'planType',
                headerName: 'Plan type',
                filter: 'agSetColumnFilter',
                hide: true
            },
            {
                field: 'customerPays',
                headerName: 'Customer pays',
                filter: 'agSetColumnFilter',
                hide: true
            },
            {
                field: 'isPromotion',
                headerName: 'isPromotion',
                filter: 'agSetColumnFilter',
                hide: true
            },
            {
                field: 'renewalCadence',
                headerName: 'renewalCadence',
                filter: 'agSetColumnFilter',
                valueFormatter: emptyCellFormatter,
                hide: true
            },
            {
                field: 'promoDurationInDays',
                headerName: 'promoDurationInDays',
                filter: 'agSetColumnFilter',
                valueGetter: getPromoDurationDays,
                valueFormatter: emptyCellFormatter,
                hide: true
            },
            {
                field: 'territory',
                headerName: 'Terr',
                filter: 'agSetColumnFilter',
                valueFormatter: emptyCellFormatter,
                cellRenderer: (params: ICellRendererParams) => getTerritoryFlagRenderer(params, false)
            }
        ]
    }
];
